import React from 'react';
import ChrWidget from '../../../generic/PageUI/Compound/ChrWidget';
import { getDefaultWidgetConfigs, getRemoteConfigs } from '../utils';
import { getCommonDateRangeWithPresetFilterValue } from '../../../generic/Utils/commonUtils';
import useWidgetActionsBuilder from '../../../../hooks/generic/Actions/useWidgetActionsBuilder';
import { getEventDetailsForDateFilter } from '../../../generic/Actions/WidgetActions/DateFilter/utils';
import { getEventDetailsHash } from '../utils';
import EngagementSurveysWidgetBody from './body';

const EngagementSurveys = (props) => {
  const { name, url, actionsData } = props;
  const defaultWidgetConfigs = getDefaultWidgetConfigs({ ...props, className: "grid-item-span-full-width" });
  const filterKey = 'respondedIn';
  const configBuilder = (state) => {
    return {
      remoteOptions: getRemoteConfigs(url, EngagementSurveysWidgetBody, { filters: getCommonDateRangeWithPresetFilterValue(state, filterKey, 'responded_in_date_range') })
    };
  }
  const { actions, widgetConfig, widgetUtils } = useWidgetActionsBuilder(actionsData, configBuilder);

  return (
    <ChrWidget
      widgetUtils={ widgetUtils }
      {...defaultWidgetConfigs}
      header={name}
      headerActions={actions.headerActions}
      {...widgetConfig.remoteOptions}
      footerActions={ actions.footerActions }
    />
  );
};

export default EngagementSurveys;